import { jwtDecode } from 'jwt-decode'

export const getLocalToken = (()=>{
    var key = 'jwt'
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    var token = sessionStorage.getItem(key)
    //return b ? b.pop() : sessionStorage.getItem(key);
    const returnData = token ? token : b ? b.pop() : ''
    return returnData
})

export const saveLocalToken = ((token)=>{
    var key = 'jwt'
    document.cookie = `${key}=${token}`
    sessionStorage.setItem(key, token);
})

export const isLoggedIn = (() => {
    return getLocalToken() !== ''
})

export const logout = (()=>{
    var key = 'jwt'
    document.cookie = `${key}=`
    sessionStorage.removeItem(key);
})

/**
 * Verifica si el token JWT ha expirado
 * @returns {boolean} true si el token ha expirado, false si sigue válido
 */
export const isTokenExpired = (() => {
    try {
        const token = getLocalToken()
        if (!token) return true
        
        const decoded = jwtDecode(token)
        const currentTime = Date.now() / 1000
        
        // Si no hay exp claim, considerar como expirado
        if (!decoded.exp) return true
        
        // Devolver true si ha expirado (exp es menor al tiempo actual)
        return decoded.exp < currentTime
    } catch (error) {
        // Si hay error al decodificar, considerar como expirado
        return true
    }
})

/**
 * Obtiene el tiempo restante hasta que expira el token (en segundos)
 * @returns {number} segundos restantes, o -1 si ya expiró
 */
export const getTokenTimeRemaining = (() => {
    try {
        const token = getLocalToken()
        if (!token) return -1
        
        const decoded = jwtDecode(token)
        const currentTime = Date.now() / 1000
        const timeRemaining = decoded.exp - currentTime
        
        return timeRemaining > 0 ? Math.floor(timeRemaining) : -1
    } catch (error) {
        return -1
    }
})
